let measurementFrame: HTMLIFrameElement | undefined;

/** Populate a hidden iframe with provided content, for analysing the content in isolation.
 * Reuses a single persistent iframe for efficiency */
const getMeasurementDoc = (content: string) => {
  if (
    // turbo nav cleans out the body content, so sometimes we end up with a reference to an iframe that's
    // no longer in the document, so we recreate it
    !measurementFrame?.contentWindow
  ) {
    measurementFrame = document.createElement('iframe');
    document.body.appendChild(measurementFrame);

    measurementFrame.style.position = 'absolute';
    measurementFrame.style.right = '100%';
    measurementFrame.style.top = '0';
  }

  if (!measurementFrame.contentWindow) {
    console.warn('Frame has no contentWindow');
    return;
  }
  measurementFrame.contentWindow.document.open();
  measurementFrame.contentWindow.document.write(`<!DOCTYPE html>${content}`);
  measurementFrame.contentWindow.document.close();

  if (!measurementFrame.contentDocument) {
    console.warn('Frame has no contentDocument');
    return;
  }
  // override unhelpful user agent styles
  measurementFrame.contentDocument.body.style.margin = '0';
  measurementFrame.contentDocument.body.style.overflow = 'none';

  return measurementFrame.contentDocument;
};

export default getMeasurementDoc;
